module.exports = __webpack_public_path__ + "images/emoji/rabbit.d3edfa7fbb02429b5d8c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rabbit.png
// module id = +ktp
// module chunks = 13